import axiosInstance from "./axiosInstance";

export interface Chat {
  id: number;              
  external_id: string;    
  title: string | null;
  created_at: string;
  messages?: any[];      
}

export const getChatsForUser = async (userId: number) => {
  const { data } = await axiosInstance.get<Chat[]>(`/chats/${userId}`);
  return data;
};

export const createChat = async (
  externalId: string,
  userId: number,
  title = ""
) => {
  const { data } = await axiosInstance.post<Chat>("/chats", {
    external_id: externalId,
    user_id:    userId,
    title
  });
  return data;
};
export async function deleteChat(chatId: number): Promise<void> {
  const res = await fetch(`https://zywajdscvz.a.pinggy.link/chats/${chatId}`, {
    method: "DELETE",
  });

  if (!res.ok) {
    throw new Error(`Error : ${res.statusText}`);
  }
}
export async function renameChat(chatId: number, title: string) {
  const res = await fetch(
    `https://zywajdscvz.a.pinggy.link/chats/${chatId}/update-title`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ title }),
    }
  );
  if (!res.ok) throw new Error("Erorr renaming chat");
  return await res.json();
}